import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, zip } from 'rxjs';
import { map, switchMapTo } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { PluginLoaderService } from '../../shared/plugin-loader.service';
import { Getter } from '../../base/interfaces';
declare const AMap: any;

const TAG = 'AmapCircle';

@Injectable()
export class AmapCircleService implements Getter<AMap.Circle> {
  private circle: any;
  private circle$ = new ReplaySubject<any>(1);
  private editor: any;
  private editor$ = new ReplaySubject<any>(1);

  constructor(
    private amaps: AMapService,
    private logger: LoggerService,
    private ngZone: NgZone,
    private plugins: PluginLoaderService,
  ) {}

  /**
   * è·ååå½¢
   */
  get() {
    return this.circle$.asObservable();
  }

  /**
   * åå»ºåå½¢ AMap.Circle
   * @param options éé¡¹
   */
  create(options: AMap.Circle.Options) {
    return this.amaps.get().pipe(
      map(m => {
        options.map = m;
        this.circle = this.ngZone.runOutsideAngular(() => new AMap.Circle(options));
        this.logger.d(TAG, 'new Circle created.');
        this.circle$.next(this.circle);
        this.circle$.complete();
        return this.circle;
      }),
    );
  }

  /**
   * éæ¯åå½¢
   */
  destroy() {
    this.get().subscribe(m => {
      m.setMap(null);
      this.logger.d(TAG, 'Circle destroyed.');
      this.circle = null;
    });
  }

  getEditor() {
    // plugin is loading:
    return this.editor$.asObservable();
  }

  /**
   * å è½½ç¼è¾æä»¶
   */
  loadEditor() {
    return this.plugins.load('AMap.CircleEditor');
  }

  /**
   * åå»ºç¼è¾å¨
   */
  createEditor() {
    return this.loadEditor().pipe(
      switchMapTo(zip(this.amaps.get(), this.get())),
      map(([m, p]) => {
        this.editor = this.ngZone.runOutsideAngular(() => new AMap.CircleEditor(m, p));
        this.logger.d(TAG, 'new CircleEditor created.');
        this.editor$.next(this.editor);
        this.editor$.complete();
        return this.editor;
      }),
    );
  }

  /**
   * å¼å³ç¼è¾å¨
   * @param v å¼å³éé¡¹
   */
  toggleEditor(v: boolean) {
    if (v && !this.editor) {
      this.createEditor().subscribe(editor => editor.open());
      return;
    }

    if (this.editor) {
      if (v) {
        this.editor.open();
      } else {
        this.editor.close();
      }
    }
  }
}
